/** Helpers for Stage Gates Phase 3b — deliverable templates and role filtering. */

export function filterDeliverablesByRole(items, role) {
  return (items || []).filter((d) => d.role === role);
}

export function partitionPhaseDeliverables(items) {
  const list = items || [];
  return {
    inherited: list.filter((d) => d.role === 'inherited_input'),
    phase: list.filter((d) => d.role === 'phase_output'),
    handover: list.filter((d) => d.role === 'handover_output'),
  };
}

/** Build insert rows from templates, skipping titles already on the gate. */
export function buildSeedRows(templates, gateId, existingItems) {
  const existing = new Set((existingItems || []).map((d) => (d.title || '').trim().toLowerCase()));
  return (templates || [])
    .filter((t) => t.name && !existing.has(t.name.trim().toLowerCase()))
    .map((t, i) => ({
      gate_id: gateId,
      title: t.name,
      description: t.description || null,
      role: t.role || 'phase_output',
      template_id: t.org_template_id || null,
      order_index: t.order_index ?? i + 1,
    }));
}

/**
 * Load org deliverable templates for a gate; fall back to platform defaults.
 * @param {import('@supabase/supabase-js').SupabaseClient} sb
 */
export async function fetchDeliverableTemplates(sb, { organisationId, gateType, stageId }) {
  if (!organisationId || !gateType) return [];

  const { data: orgRows } = await sb
    .from('org_gate_deliverable_templates')
    .select('id, name, description, role, order_index, stage_id, gate_type')
    .eq('organisation_id', organisationId)
    .eq('gate_type', gateType)
    .eq('is_active', true)
    .order('order_index');

  let templates = (orgRows || []).map((r) => ({ ...r, org_template_id: r.id }));

  if (!templates.length) {
    const { data: platformRows } = await sb
      .from('gate_deliverable_templates')
      .select('id, name, description, role, order_index, stage_id, gate_type')
      .eq('gate_type', gateType)
      .eq('is_default', true)
      .order('order_index');
    templates = platformRows || [];
  }

  if (stageId) {
    templates = templates.filter((t) => !t.stage_id || t.stage_id === stageId);
  }

  return templates;
}

/** Exit criteria only — scorecard excludes non-exit criterion types. */
export function exitCriteriaOnly(criteria) {
  return (criteria || []).filter((c) => !c.criterion_type || c.criterion_type === 'exit_check');
}
